import { Command } from 'commander';
import { createConnectCacheGetCommand } from './get.js';
import { createConnectCacheSetCommand } from './set.js';
import { createConnectCacheDeleteCommand } from './delete.js';

export function createConnectCacheCommand(): Command {
    const cmd = new Command('cache')
        .description('Cache access commands');

    cmd.addCommand(createConnectCacheGetCommand());
    cmd.addCommand(createConnectCacheSetCommand());
    cmd.addCommand(createConnectCacheDeleteCommand());
    return cmd;
}

